import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { SaveButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, zoneValidations } from "./zone-schema";
import { useWhOptionsQuery } from "hooks/useWhQuery";
import { getZone, editZone } from "services/data.internal.service";
import ZoneInfo from "./components/ZoneInfo";
import { useLocation } from "react-router-dom";

function EditZone() {
  const location = useLocation();
  const { warehouseCode, zoneID } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const [whOptions, setWhOptions] = useState([]);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["zone", { warehouseCode, zoneID }],
    queryFn: () => getZone({ warehouseCode, zoneID }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });
  const editZoneMutation = useMutation(editZone, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(zoneValidations),
  });

  const {
    getValues,
    control,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
  } = form;

  useWhOptionsQuery({
    onSuccess: (data) => setWhOptions(data.data.data),
  });

  const infoProps = {
    mode: "EDIT",
    whOptions,
    getValues,
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    editZoneMutation.mutate({ warehouseCode, zoneID, req: data }, {
      onSuccess: () => queryClient.invalidateQueries(["zone"])
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <ZoneInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty} url="/setup/zone" />
      </form>
    </Layout>
  );
}

export default EditZone;
